import React, { memo } from "react";
import ContentPostLayout from "@Components/ContentPostLayout";
import FAQs from "@Pages/Search/components/FAQ";
import SectionContainer from "@Pages/PropertyPage/components/SectionContainer";
import BlogsSidebar from "@Pages/Blog/BlogHome/components/BlogsSidebar/BlogsSidebar";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./BlogPost.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

type TocItem = { id?: string; text: string; level?: number | string };

type Props = {
  blogData: any;
  articleContent: React.ReactNode[];
  tableOfContents: TocItem[];
  processedFaqItems: any[];
  formatDate: (dateString: string) => string;
  basePath?: string;
};

const BlogPostContent: React.FC<Props> = ({
  blogData,
  articleContent,
  tableOfContents,
  processedFaqItems,
  formatDate,
  basePath = "/blog",
}) => {
  const { t } = useTranslationHook();
  const faqContent =
    processedFaqItems && processedFaqItems.length > 0 ? (
      <SectionContainer
        title={t("blog.blogPostcontent.faqTitle")}
        dataTestId="search-inventory-faq-section"
        id="faqs"
        className={formatClassNames(styles.desktop, styles.desktopSectionContainer)}
      >
        <FAQs
          data={processedFaqItems}
          propertyPageGtagEvents
          dataTestId="faq"
          addSearchBar={false}
        />
      </SectionContainer>
    ) : undefined;

  return (
    <ContentPostLayout
      postData={blogData}
      articleContent={articleContent}
      tableOfContents={tableOfContents}
      formatDate={formatDate}
      basePath={basePath}
      breadcrumbLabel="blog.grid.breadcrumb.blogs"
      sidebarContent={<BlogsSidebar />}
      faqContent={faqContent}
    />
  );
};

export default wrapperHOC(memo(BlogPostContent), {
  componentName: "BlogPostContent-Blog",
  showForChina: true,
});
